

<form [formGroup]="form" (ngSubmit)="onSubmit()">

  <formly-form
  [form]="form"
  [model]="model"
  [fields]="fields"
  (modelChange)="modelChange()"
  >
</formly-form>
<div class="form-group" *ngIf="mostrarBotonArchivo">
  <input id="upload-file-button" class="confirm btn-default-primary" type="file" (change)="uploadFile($event)" #hiddenfileinput>
  <button (click)="hiddenfileinput.click()" type="button" class="waves-effect waves-light btn"><i class="material-icons left">cloud_upload</i> Seleccionar un archivo</button>
  <span id="file-label" >
    {{nombreDelArchivo}}
  </span>
</div>

<!--
  <button type="submit" color="primary" mat-raised-button>
    Submit
  </button>

  <button type="reset" color="warn" mat-raised-button>
    Reset
  </button>
-->
  <div class="form-buttons" >
    <button class="reset btn-default-secondary" type="button"
      (click)="eliminarOrdenDeTrabajo(ordenDeTrabajoId)" [disabled]="submitted" *ngIf="mostrarBotonEliminar">Eliminar</button>
    <button class="reset btn-default-secondary" type="button"
      (click)="resetForm()" [disabled]="submitted" *ngIf="mostrarBotonCancelar">Limpiar</button>
    <button class="confirm btn-default-primary" type="submit"
      [disabled]="!form.valid || (submitted && this.accion=='adjuntoNuevo')" *ngIf="mostrarBotonAceptar">Confirmar</button>
  </div>
</form>
